<template>
    <div id="approve-budget-task">
        <modals-container @confirmApproveBudget="confirmApproveBudget"></modals-container>
        <router-link
                :to="{name: 'ActualCostsWork', params: {id: additionalData.sheet_id, type: 'personnel', heading: 'work', lastRoute: 'Tasks', projectId: additionalData.project_id}}"
                class="btn btn-sm btn-primary mr-2">Review
        </router-link>
        <button v-if="newTab" @click="approveBudgetModal('approve')" class="btn btn-sm btn-success mr-2">Approve</button>
        <button v-if="newTab" @click="approveBudgetModal('deny')" class="btn btn-sm btn-danger mr-2">Deny</button>
        <!-- <div style="display: inline-block; margin-bottom: 2px" class="form-group"><input v-model="additionalData.amount"
                                                                                         type="number"
                                                                                         class="form-control"></div> -->
    </div>
</template>

<script>
  import DialogModal from '../../../modals/DialogModal'

  export default {
    name: 'ApproveBudgetTask',
    props: ['additionalData', 'taskId', 'newTab'],
    data () {
      return {}
    },
    methods: {
      approveBudgetModal (param) {
        this.additionalData.taskId = this.taskId
        const msg = `${param === 'approve' ? this.$t('message.areYouSureThatYouWantToApprove') : this.$t('message.areYouSureThatYouWantToDeny')} ${this.additionalData.company_name}?`
        this.additionalData['approved'] = param === 'approve'
        this.additionalData['message'] = `${param === 'approve' ? this.$t('message.adminApprovedAdditionalBudget') : this.$t('message.adminDeniedAdditionalBudget')}.`

        this.$modal.show(DialogModal, {
            text: msg,
            param: this.additionalData,
            event: 'confirmApproveBudget'
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })
    
      },
       async confirmApproveBudget (data) {
        try {
          const response = await this.update(this.apiPrefix, this.tasksApiUrl + 'approve-additional-budget/', data.taskId, data)
          this.$emit('taskUpdated', response.data)
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>

<style scoped>
</style>